import { useCallback } from "react";

import { langCodeToJapanese } from "@/lib/chillnn/lang-code";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { VoucherI18nUpdate_EditPage_Mutation } from "./mutation";
import { viewModelToInputConverter } from "../_shared/mutation/composition/view-model-to-input";

import type { MarketingVoucherI18nFormModel } from "../../../type";

export const useVoucherI18nEditMutation = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(VoucherI18nUpdate_EditPage_Mutation);

	const onUpdate = useCallback(
		(
			viewModel: MarketingVoucherI18nFormModel["ViewModel"], //
		) => {
			showLoadingScreenCallback();

			const input = viewModelToInputConverter({ viewModel });
			const { lang } = input;

			const langText = langCodeToJapanese(lang);

			mutationFunc({
				variables: {
					input,
				},
			})
				.then(({ errors }) => {
					if (!errors) {
						notifyUserEventInfo({
							variant: "default",
							title: `宿泊券(${langText})を更新しました`,
						});
					}
				})
				.finally(() => {
					hideLoadingScreenCallback();
				});
		},
		[hideLoadingScreenCallback, mutationFunc, showLoadingScreenCallback],
	);

	return { onUpdate };
};
